import setDocument from "../../utils/setDocument";
import updateDocumentData from "../../utils/updateDocumentData";

import { ExportPreset } from "./types/ExportPreset";

export default async function updateExportPreset(firebase, data) {
	const exportPreset = ExportPreset.partial().parse(updateDocumentData(firebase, data));

	return setDocument(exportPreset);
}
